<template src='./Icono.html'></template>
<script>
export default {
  props: {
    nombreIcono: {
      type: String,
      default: "null"
    },
    width: {
      type: [Number, String],
      default: 24
    },
    height: {
      type: [Number, String],
      default: 24
    },
    colorIcono: {
      type: String,
      default: "currentColor"
    },
    value: {
      type: String,
      default:
        "M43,44H1c-0.6,0-1-0.4-1-1V1c0-0.6,0.4-1,1-1h42c0.6,0,1,0.4,1,1v42C44,43.6,43.6,44,43,44z M2,42h40V2H2V42z"
    }
  }
};
</script>
<style lang="scss" scoped src='./Icono.css'>
</style>


// WEBPACK FOOTER //
// src/components/Icono/Icono.vue